/* Dependencies */
import styled from 'styled-components';

/* Icons */
import { ReactComponent as Arrow } from 'images/icons/sortingArrowDown.svg';
import { ReactComponent as Info } from 'images/icons/info.svg';

export const List = styled.div.attrs(() => ({
  className: 'ClassroomList',
}))`
  width: 100%;
`;

export const ClassroomHeader = styled.div.attrs(() => ({
  className: 'ClassroomListHeader',
}))`
  display: grid;
  grid-template-columns: repeat(14, 1fr);
  grid-template-rows: 40px;
  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.colors.shadeMediumLight};
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px;
  margin-bottom: 10px;
`;

export const ClassroomName = styled.div.attrs(() => ({
  className: 'ClassroomListName',
}))`
  grid-column: 1 / 9;

  display: flex;
  align-items: center;
`;

export const SortArrow = styled(Arrow).attrs(() => ({
  className: 'ClassroomListUpArrow',
}))`
  height: 10px;
  width: 14px;

  margin-left: 20px;

  &:hover {
    cursor: pointer;
  }
`;

export const StudentCount = styled.div.attrs(() => ({
  className: 'ClassroomStudentCount',
}))`
  display: none;
  grid-column: 9 / 11;

  ${({ theme }) => theme.breakPoints.tablet} {
    display: block;
  }
`;

export const StyledClassCodeWrapper = styled.div.attrs(() => ({
  className: 'ClassroomCode',
}))`
  display: none;
  grid-column: 11 / 14;
  position: relative;

  ${({ theme }) => theme.breakPoints.tablet} {
    display: flex;
    align-items: center;
  }
`;

export const InfoBtn = styled(Info).attrs(() => ({
  className: 'ClassroomCodeInfoButton',
}))`
  height: 24px;
  width: 24px;

  margin-left: 10px;

  #Oval {
    stroke: ${({ theme }) => theme.colors.shadeMedium};
  }
  #i {
    fill: ${({ theme }) => theme.colors.shadeMedium};
  }
`;

export const ListEmpty = styled.div.attrs(() => ({
  className: 'ClassroomListEmptyState',
}))`
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.colors.shadeMediumDark};
  font-size: 16px;
  margin: 100px auto;
`;

export const HelperText = styled.div.attrs(() => ({
  className: 'HelperText',
}))`
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.shadeMedium};
  border-radius: 5px;
  color: #748C98;
  font-size: 14px;
  margin: 0;
  padding: 10px;
  width: 240px;
  z-index: 8000;

  position: absolute;
  top: 28px;
  right: 110px;
`;
